import { success } from "App/popupMessage";
import signalR from "Common/signalR";
import locale from "./actionCreators.locale";
import actionTypes from "./actionTypes";
import api from "./api";
export default {
    getSettings: () => ({
        type: actionTypes.GET_SETTINGS,
        payload: {
            promise: () => api.getSettings()
        }
    }),
    getSettingsTypeDictionary: () => ({
        type: actionTypes.GET_SETTINGS_TYPE_DICTIONARY,
        payload: {
            promise: () => api.getSettingsTypeDictionary()
        }
    }),
    reloadOntology: (completed) => ({
        type: actionTypes.RELOAD_ONTOLOGY,
        payload: {
            promise: () => { var _a; return api.reloadOntology((_a = signalR.connection) === null || _a === void 0 ? void 0 : _a.connectionId); }
        },
        completed: (dispatch) => {
            dispatch(success(locale.ONTOLOGY_RELOADED_SUCCESSFULLY));
            completed && completed();
        }
    }),
    testConnection: (data, completed) => ({
        type: actionTypes.TEST_CONNECTION,
        payload: {
            promise: () => api.testConnection(data)
        },
        meta: { id: data.Type },
        completed: (dispatch) => {
            dispatch(success(locale.CONNECTION_TESTED_SUCCESSFULLY));
            completed && completed();
        },
        scope: `${actionTypes.TEST_CONNECTION}_${data.Type}`
    }),
    saveConnection: (data, completed) => ({
        type: actionTypes.SAVE_CONNECTION,
        payload: {
            promise: () => api.saveConnection(data)
        },
        meta: { id: data.Type },
        completed: (dispatch) => {
            dispatch(success(locale.CONNECTION_SAVED_SUCCESSFULLY));
            completed && completed();
        },
        scope: `${actionTypes.SAVE_CONNECTION}_${data.Type}`
    }),
    saveSetting: (data, completed) => ({
        type: actionTypes.SAVE_SETTING,
        payload: {
            promise: () => api.saveSetting(data)
        },
        meta: { id: data.Type },
        completed: (dispatch) => {
            dispatch(success(locale.SETTING_SAVED_SUCCESSFULLY));
            completed && completed();
        },
        scope: `${actionTypes.SAVE_SETTING}_${data.Type}`
    })
};
